import { render, staticRenderFns } from "./roleChange.vue?vue&type=template&id=00bd3e84&scoped=true&"
import script from "./roleChange.vue?vue&type=script&lang=js&"
export * from "./roleChange.vue?vue&type=script&lang=js&"
import style0 from "./roleChange.vue?vue&type=style&index=0&id=00bd3e84&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bd3e84",
  null
  
)

export default component.exports